import api from "./api";

export const incrementCounter = async (path, fasyankesId) => {
  const regionId = String(fasyankesId || "").split("|")[0];
  if (!regionId) return;
  try {
    await api.post(path, { regionId });
  } catch (err) {
    console.warn("Gagal increment notifikasi", path, err);
  }
};
